<template>
  <div>
    <!-- Create or Edit an item -->

    <v-dialog
      v-model="formDialog"
      :max-width="source == 'shipping_market' ? 640 : 1024"
      persistent
      scrollable
      :transition="false"
      :fullscreen="
        this.$vuetify.breakpoint.md ||
        this.$vuetify.breakpoint.sm ||
        this.$vuetify.breakpoint.xs
      "
    >
      <v-card>
        <v-toolbar
          tile
          card
          flat
          height="36"
          color="theme_primary"
          class="white--text"
        >
          <v-toolbar-side-icon>
            <v-icon small color="white">{{ icon }}</v-icon>
          </v-toolbar-side-icon>
          <v-spacer></v-spacer>
          <v-toolbar-title class="white-text text-capitalize subheading">
            {{ (currentObject.id ? "Edit " : "Add a new ") + singularName() }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-for="field in inputFields" :key="field.name">
            <v-text-field
              :placeholder="field.name == 'icon' ? 'exemple: tag-outlined' : ''"
              :class="
                field.name == 'subject' ||
                field.name == 'recipient' ||
                field.name == 'cc' ||
                field.name == 'bcc'
                  ? 'text_field_action'
                  : ''
              "
              :id="'text_field_' + field.name"
              v-if="
                field.type.name != 'Boolean' &&
                field.type.kind != 'ENUM' &&
                !field.name.endsWith('_id') &&
                !field.name.endsWith('_ids') &&
                field.description != 'file_upload' &&
                field.description != 'text' &&
                field.description != 'date' &&
                field.name != 'color'
              "
              autocomplete="nothingplease"
              @change="fillObject(field.name, $event)"
              :label="camelize(field.name, ' ')"
              background-color="white"
              :value="currentObject[field.name]"
              @click:append="setEmailPlaceholderModaleTarget(field.name)"
              :append-icon="
                field.name == 'subject' ||
                field.name == 'recipient' ||
                field.name == 'cc' ||
                field.name == 'bcc'
                  ? 'settings_ethernet'
                  : ''
              "
            >
              <v-tooltip slot="append-outer" bottom v-if="field.name == 'icon'">
                <v-icon slot="activator" class="help_icon" dark>help</v-icon>
                <IconExemples />
              </v-tooltip>

              <template
                v-if="
                  field.name == 'icon' &&
                  currentObject[field.name] &&
                  currentObject[field.name] != 'null'
                "
                slot="append"
              >
                <v-icon class="pr-4">{{ currentObject[field.name] }}</v-icon>
              </template>
            </v-text-field>

            <div v-if="field.name == 'color'" style="height: 200px;">
              <v-swatches
                :swatches="predefinedColors"
                v-model="selectedColor"
                style="width: 100%;"
              >
                <v-text-field
                  label="Color"
                  slot="trigger"
                  :value="currentObject[field.name]"
                  readonly
                >
                  <template slot="append">
                    <v-icon :color="currentObject[field.name]"
                      >mdi-palette</v-icon
                    >
                  </template>
                </v-text-field>
              </v-swatches>
            </div>

            <v-subheader
              style="font-size: 12px;"
              v-if="field.description == 'text'"
              >{{ camelize(field.name, " ") }}:</v-subheader
            >

            <!-- Use CK editor for text fields -->
            <template v-if="field.description == 'text'">
              <!-- Word editor layout like for PDFs -->
              <div class="px-2" v-if="resourceDisplayName == 'Pdf Templates'">
                <div class="document-editor">
                  <div class="document-editor__toolbar"></div>
                  <div class="document-editor__editable-container">
                    <div class="document-editor__editable">
                      <ckeditor
                        class="ckeditor_main_container"
                        :editor="editor"
                        v-model="currentObject[field.name]"
                        :config="editorConfig"
                        @ready="onReady"
                      ></ckeditor>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Classic Layout for eMails, Signatures.. -->
              <div class="px-2" v-else>
                <div class="document-editor">
                  <div class="document-editor__toolbar"></div>
                  <ckeditor
                    @ready="onReady"
                    :editor="editor"
                    v-model="currentObject[field.name]"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </div>
            </template>

            <v-dialog
              width="960"
              v-if="field.description == 'text'"
              v-model="PlaceholderModale"
            >
              <v-toolbar
                dark
                card
                dense
                height="36"
                color="theme_primary"
                class="bordered white--text"
              >
                <v-icon small pa-0 color="white">settings_ethernet</v-icon>
                <v-toolbar-title style="margin-left: 8px;">
                  <h6>CTC Variables</h6>
                </v-toolbar-title>
              </v-toolbar>
              <v-card>
                <v-card-text class="pa-0">
                  <v-list class="pt-0" dense>
                    <v-list-group
                      class="reducedLPadding"
                      v-for="group in text_interpolations"
                      :key="group.title"
                      v-model="group.active"
                      :prepend-icon="group.icon"
                      no-action
                      ripple
                    >
                      <template v-slot:activator>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>{{
                              titleCase(group.title)
                            }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                      <v-container grid-list-md text-xs-center>
                        <v-layout
                          row
                          wrap
                          v-if="
                            group.title != 'Products' &&
                            group.title != 'Expedition Products'
                          "
                        >
                          <v-flex
                            :v-if="ctcVariable.name != '{{ null }}'"
                            v-for="ctcVariable in group.variables"
                            :key="ctcVariable.name"
                            xs6
                          >
                            <v-list-tile
                              @click="emailPlaceholderInsert(ctcVariable.name)"
                            >
                              <v-list-tile-action>
                                <v-icon color="#121212"
                                  >settings_ethernet</v-icon
                                >
                              </v-list-tile-action>

                              <v-list-tile-content>
                                <v-list-tile-title>{{
                                  ctcVariable.name.replace(/[{}]/g, "")
                                }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{
                                  ctcVariable.description
                                }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap v-else>
                          <v-flex xs12>
                            <v-input
                              class="pl-3"
                              :messages="[
                                'Select which variables you need in your table',
                              ]"
                              >Products Tables</v-input
                            >
                            <br />
                            <v-layout wrap row class="pb-4">
                              <v-btn
                                style="float: left;"
                                @click="plmLoopToggle(ctcVariable)"
                                outine
                                v-for="(ctcVariable, index) in group.variables"
                                :key="index"
                                :color="
                                  placeholderModaleLoopArray.indexOf(
                                    ctcVariable.name
                                  ) == -1
                                    ? 'white'
                                    : placeholderModaleLoopObjects[
                                        ctcVariable.name
                                      ].need_total
                                    ? 'success'
                                    : 'primary'
                                "
                                >{{ plmLoopButtonName(ctcVariable) }}</v-btn
                              >
                            </v-layout>

                            <v-layout wrap row class="pb-4">
                              <v-checkbox
                                label="Show headers"
                                v-model="interpolated_headers"
                              ></v-checkbox>
                            </v-layout>

                            <v-subheader class="pb-2">Preview:</v-subheader>

                            <div class="px-2 pt-0">
                              <div class="document-editor">
                                <div class="ckeditor_main_container">
                                  <div
                                    class="ck ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-blurred"
                                    v-html="plmLoopHtml"
                                  ></div>
                                </div>
                              </div>
                            </div>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                @click="
                                  emailPlaceholderInsert(
                                    plmLoopExport(group.title)
                                  )
                                "
                                style="float: right;"
                                color="primary"
                                flat
                              >
                                <v-icon small left>settings_ethernet</v-icon
                                >Insert code
                              </v-btn>
                            </v-card-actions>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-list-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-dialog>

            <div v-if="field.description == 'file_upload'">
              <uploader
                :displayName="
                  'Upload here the ' +
                  camelize(field.name.replace('_url', ''), ' ') +
                  ' file'
                "
                :name="field.name"
                v-on:s3url="fillObject(field.name, $event)"
              />
              <a
                v-if="currentObject[field.name]"
                target="_blank"
                :href="`${s3bucket}/${currentObject[field.name]}`"
                >{{ currentObject[field.name] }}</a
              >
            </div>

            <v-checkbox
              v-if="field.type.name == 'Boolean'"
              autocomplete="nothingplease"
              @change="fillObject(field.name, $event)"
              :label="camelize(field.name, ' ')"
              background-color="white"
              :value="currentObject[field.name]"
              :input-value="currentObject[field.name]"
              height="8"
            ></v-checkbox>

            <v-autocomplete
              v-if="field.type.kind == 'ENUM'"
              :items="field.type.enumValues"
              item-value="name"
              item-text="name"
              background-color="white"
              @change="fillObject(field.name, $event)"
              browser-autocomplete="noautocomplete"
              :value="currentObject[field.name]"
              :label="camelize(field.name, ' ')"
              chips
            ></v-autocomplete>

            <v-autocomplete
              v-if="
                field.name.endsWith('_ids') &&
                field.description !== 'role_actions' &&
                field.name !== 'owned_company_ids'
              "
              :items="fetchCollection(field)"
              item-value="id"
              item-text="name"
              background-color="white"
              @change="fillObject(field.name, $event)"
              multiple
              browser-autocomplete="noautocomplete"
              :value="currentObject[field.name]"
              :label="multipleLabel(field)"
              append-icon="library_add"
              :search-input.sync="searchInput"
              @click:append="addAll(field.name)"
              clearable
            ></v-autocomplete>

            <v-autocomplete
              v-if="field.name === 'owned_company_ids'"
              :items="fetchCollection(field)"
              item-value="id"
              item-text="name"
              background-color="white"
              @change="fillObject(field.name, $event)"
              multiple
              browser-autocomplete="noautocomplete"
              :value="currentObject[field.name]"
              :label="multipleLabel(field)"
            ></v-autocomplete>

            <v-menu
              v-if="field.description == 'date'"
              ref="menu"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                v-if="field.description == 'date'"
                slot="activator"
                v-model="currentObject[field.name]"
                :label="camelize(field.name, ' ')"
                background-color="white"
                prepend-inner-icon="event"
                readonly
              />

              <v-date-picker
                v-if="field.description == 'date'"
                @change="fillObject(field.name, $event)"
                no-title
                scrollable
              />
            </v-menu>

            <div
              v-if="
                field.description == 'role_actions' &&
                currentObject['available_action_ids']
              "
            >
              <v-subheader>
                Available Actions:
                <v-spacer></v-spacer>

                <template v-if="actionTab">
                  <span>
                    Set all available actions in
                    <b>{{ actionTab }}</b> as
                  </span>
                  <v-btn
                    flat
                    icon
                    small
                    dark
                    round
                    v-for="n in 3"
                    :key="n"
                    :color="defineIconColor(n)"
                    @click="
                      udpateCurrentCategoryActions(
                        fetchAvailableActionsByGroup()[actionTab],
                        n
                      )
                    "
                  >
                    <b class="capitalize">{{ actionsRadioGroupLabel(n) }}</b>
                  </v-btn>
                </template>
              </v-subheader>

              <div class="px-3">
                <v-tabs
                  grow
                  dark
                  v-model="actionTab"
                  left
                  color="theme_primary_darken1"
                  slider-color="theme_primary"
                  height="36"
                  dense
                  show-arrows
                >
                  <v-tab
                    active-class="active-tab primary--text"
                    v-for="(actionGroup,
                    index) in fetchAvailableActionsByGroup()"
                    :key="index"
                    :href="'#' + index"
                  >
                    <span class="font-weight-bold pl-2">{{ index }}</span>
                  </v-tab>
                </v-tabs>
                <v-tabs-slider></v-tabs-slider>
                <v-tabs-items v-model="actionTab">
                  <v-tab-item
                    v-for="(actionGroup,
                    index) in fetchAvailableActionsByGroup()"
                    :key="index"
                    :value="index"
                    lazy
                  >
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-container
                          class="pa-0 mx-0"
                          fluid
                          grid-list-md
                          text-xs-center
                        >
                          <v-layout row wrap>
                            <v-flex
                              xs12
                              sm6
                              v-for="actionCategory in actionGroup"
                              :key="actionCategory[0]"
                            >
                              <v-expansion-panel class="mini">
                                <v-expansion-panel-content>
                                  <template v-slot:header>
                                    <div>{{ actionCategory.pluralized }}</div>
                                    <v-spacer></v-spacer>
                                    <v-flex text-xs-right>
                                      <v-tooltip
                                        top
                                        small
                                        class="px-0"
                                        v-for="actionType in actionCategory.actions"
                                        :key="actionType.name"
                                      >
                                        <v-icon
                                          size="18"
                                          style="user-select: none;"
                                          flat
                                          slot="activator"
                                          v-model="actionType.value"
                                          @click.stop="
                                            udpateCurrentObjectActions(
                                              actionType,
                                              actionType.value + 1
                                            )
                                          "
                                          :color="
                                            defineIconColor(
                                              actionsRadioGroupValue(actionType)
                                            )
                                          "
                                          >{{ actionType.icon }}</v-icon
                                        >
                                        <span class="capitalize">
                                          {{
                                            actionType.name +
                                            "- " +
                                            actionsRadioGroupLabel(
                                              actionsRadioGroupValue(actionType)
                                            )
                                          }}
                                        </span>
                                      </v-tooltip>
                                    </v-flex>
                                  </template>
                                  <v-card flat>
                                    <v-card-text class="py-0 pb-2">
                                      <v-container
                                        class="pa-0 mx-0"
                                        fluid
                                        grid-list-md
                                        text-xs-center
                                        align-start
                                      >
                                        <v-layout row wrap>
                                          <v-flex
                                            sm6
                                            md3
                                            v-for="actionType in actionCategory.actions"
                                            :key="actionType.name"
                                          >
                                            <v-radio-group
                                              hide-details
                                              class="mt-0"
                                              v-model="actionType.value"
                                            >
                                              <label
                                                class="text-capitalize grey--text"
                                              >
                                                <v-icon
                                                  size="2"
                                                  color="grey"
                                                  class="pr-1"
                                                  >{{ actionType.icon }}</v-icon
                                                >
                                                {{ actionType.name }}
                                              </label>
                                              <v-divider
                                                class="pt-2"
                                              ></v-divider>
                                              <v-radio
                                                v-for="n in 3"
                                                :key="n"
                                                class="pa-0"
                                                v-show="
                                                  !(
                                                    n == 2 &&
                                                    actionType.name == 'see'
                                                  )
                                                "
                                                :color="defineIconColor(n)"
                                                :value="n"
                                                @change="
                                                  udpateCurrentObjectActions(
                                                    actionType,
                                                    n
                                                  )
                                                "
                                                :label="
                                                  actionsRadioGroupLabel(n)
                                                "
                                              ></v-radio>
                                            </v-radio-group>
                                          </v-flex>
                                        </v-layout>
                                      </v-container>
                                    </v-card-text>
                                  </v-card>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </div>

            <template
              v-if="
                field.description == 'role_actions' &&
                !currentObject['available_action_ids']
              "
            >
              <v-subheader>Available Actions:</v-subheader>
              <v-alert :value="true" type="info">
                Available actions will be available after saving the new role.
              </v-alert>
            </template>

            <v-autocomplete
              v-if="
                field.name.endsWith('_id') &&
                !(
                  source == 'shipping_market' &&
                  (field.name == 'company_id' ||
                    field.name == 'supplier_type_id')
                )
              "
              :items="fetchCollection(field)"
              item-value="id"
              item-text="name"
              background-color="white"
              @change="fillObject(field.name, $event)"
              browser-autocomplete="noautocomplete"
              :value="currentObject[field.name]"
              :label="camelize(field.name.replace('_id', ''), ' ')"
              chips
            ></v-autocomplete>

            <v-autocomplete
              v-if="
                field.name.endsWith('_id') &&
                source == 'shipping_market' &&
                field.name == 'company_id'
              "
              :items="filteredCompanies"
              item-value="id"
              item-text="name"
              background-color="white"
              @change="fillObject(field.name, $event)"
              browser-autocomplete="noautocomplete"
              :value="currentObject[field.name]"
              :label="camelize(field.name.replace('_id', ''), ' ')"
              chips
            ></v-autocomplete>

            <v-autocomplete
              v-if="
                field.name.endsWith('_id') &&
                source == 'shipping_market' &&
                field.name == 'supplier_type_id'
              "
              :disabled="true"
              :items="fetchCollection(field)"
              item-value="id"
              item-text="name"
              background-color="white"
              @change="fillObject(field.name, $event)"
              browser-autocomplete="noautocomplete"
              :value="
                currentObject[field.name] ||
                supplier_types.find((s) => s.name == resourceDisplayName).id
              "
              :label="camelize(field.name.replace('_id', ''), ' ')"
              chips
            ></v-autocomplete>
          </div>

          <!--  -->
        </v-card-text>
        <v-flex px-4 pt4>
          <v-divider></v-divider>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" flat="flat" @click="cancel">Cancel</v-btn>

          <v-btn color="green darken-1" flat="flat" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <integratedSearchBar
      :button_display="currentUserCan('create', singular(resourceName))"
      button_type="function"
      :button_function="showCreateDialog"
      :button_label="'Create a new ' + singularName()"
      v-bind:search.sync="integrated_search"
      :search_label="'Search for ' + resourceDisplayName + '...'"
      :dialog.sync="formDialog"
    />

    <v-data-table
      :headers="fetchHeaders()"
      :items="collection"
      :pagination.sync="pagination"
      :search="filters"
      :custom-filter="customFilter"
      :rows-per-page-text="resourceDisplayName + ' per page'"
    >
      <template slot="items" slot-scope="props">
        <td v-for="column of columnsArray" :key="column">
          <!-- Disabled until solution is found (in freight waiver pages we need all the data displayed, tooltip is hiding a part of it) -->
          <!-- <v-tooltip bottom >
            <span slot="activator">{{ truncate(String(fetchValue(props.item, column)), 125) }}</span>
            <span>{{ fetchValue(props.item, column) }}</span>
          </v-tooltip> -->
          <div v-show="column != 'online'">
            <userAvatar
              class="pr-4 hidden-xs-only"
              v-if="column == 'first_name' && resourceName == 'users'"
              :size="24"
              :last_name="props.item.last_name"
              :first_name="props.item.first_name"
              :url="props.item.avatar_url"
            />

            <flag
              class="pr-4"
              v-if="column == 'name' && resourceName == 'countries'"
              :iso="props.item.iso_code"
            />

            <v-icon
              v-if="
                column == 'icon' &&
                fetchValue(props.item, column) &&
                fetchValue(props.item, column) != 'null'
              "
              color="#888"
              small
              class="pr-1"
              >{{ fetchValue(props.item, column) }}</v-icon
            >

            <v-icon
              class="pr-1"
              v-if="column == 'color'"
              small
              :color="fetchValue(props.item, column)"
              >mdi-palette</v-icon
            >
            <!-- ACTUAL VALUE DISPLAYED IN DATATABLE -->
            <span
              v-show="
                fetchValue(props.item, column) &&
                fetchValue(props.item, column) != 'null'
              "
              >{{ fetchValue(props.item, column) }}</span
            >
          </div>

          <div v-if="column == 'online'" class="text-xs-left">
            <v-icon :color="props.item.online ? 'green' : 'grey'"
              >fiber_manual_record</v-icon
            >
          </div>
        </td>

        <td>
          <v-layout>
            <updatePasswordButton
              :user="props.item"
              v-if="resourceName == 'users'"
            />

            <v-btn
              flat
              round
              fab
              small
              v-if="currentUserCan('update', singular(resourceName))"
              @click="showEditDialog(props.item)"
              color="theme_primary"
            >
              <v-icon>edit</v-icon>
            </v-btn>

            <v-btn
              flat
              round
              fab
              small
              v-if="
                (resourceName == 'pdf_templates' ||
                  resourceName == 'email_templates') &&
                currentUserCan('create', singular(resourceName))
              "
              @click="duplicate(props.item)"
              color="theme_primary"
            >
              <v-icon>file_copy</v-icon>
            </v-btn>
            <destroyModale
              v-if="currentUserCan('delete', singular(resourceName))"
              :resourceName="resourceName"
              :itemId="props.item.id"
              :small="true"
              color="error"
              :collection="$store.state.commonStore[plural(resourceName)]"
              :warningText="
                'You are going to remove this ' +
                camelize(singularName(), ' ') +
                ' permanently.'
              "
            />
          </v-layout>
        </td>
      </template>

      <v-alert slot="no-results" :value="true" color="error" icon="warning"
        >Your search for "{{ filters.search }}" found no results.</v-alert
      >
    </v-data-table>

    <v-dialog v-model="mutationLoading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading... Please wait.
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import integratedSearchBar from "../shared/integratedSearchBar";
import uploader from "../shared/uploader";
import pluralize from "pluralize";
import gql from "graphql-tag";
import updatePasswordButton from "./updatePasswordButton";
import { mapGetters } from "vuex";
//CKEditor Imports:
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditor from "@ckeditor/ckeditor5-vue";

import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
//import AutoformatPlugin from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import BlockQuotePlugin from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import AlignmentPlugin from "@ckeditor/ckeditor5-alignment/src/alignment";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import EmailPlaceholder from "../../plugins/email_placeholder/emailPlaceholder";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed";
import Mention from "@ckeditor/ckeditor5-mention/src/mention";
import Font from "@ckeditor/ckeditor5-font/src/font";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageUploader from "@ckeditor/ckeditor5-image/src/imageupload";
import IconExemples from "../shared/icon_exemples";
import date from "../../mixins/date.js";
import userAvatar from "../shared/userAvatar";
import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";

export default {
  mixins: [date],
  components: {
    ckeditor: CKEditor.component,
    integratedSearchBar,
    uploader,
    updatePasswordButton,
    IconExemples,
    userAvatar,
    VSwatches,
  },
  props: {
    resourceName: {
      type: String,
      required: true,
    },
    resourceDisplayName: {
      type: String,
      required: true,
    },
    columnsArray: {
      type: Array,
      required: true,
    },
    collection: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: "public",
    },
    source: {
      type: String,
      required: false,
      default: "admin",
    },
  },
  data() {
    return {
      tmpObject: {},
      placeholderModaleTarget: -1,
      placeholderModaleLoopArray: [],
      placeholderModaleLoopObjects: {},
      mutationLoading: false,
      editor: ClassicEditor,
      predefinedColors: [
        "#f44336",
        "#E91E63",
        "#9C27B0",
        "#673AB7",
        "#3F51B5",
        "#2196F3",
        "#03A9F4",
        "#00BCD4",
        "#009688",
        "#4CAF50",
        "#8BC34A",
        "#CDDC39",
        "#FFEE58",
        "#FFEB3B",
        "#FFC107",
        "#FF9800",
        "#FF5722",
        "#795548",
        "#E0E0E0",
        "#9E9E9E",
        "#424242",
        "#607D8B",
        "#212121",
      ],
      selectedColor: "#f44336",
      editorConfig: {
        mention: {
          feeds: [
            {
              marker: "{",
              feed: this.allTextInterpolationsAsArray(),
              minimumCharacters: 0,
              itemRenderer: this.ctcVariableSnippetList,
            },
          ],
        },
        plugins: [
          Mention,
          EssentialsPlugin,
          //AutoformatPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ListPlugin,
          ParagraphPlugin,
          BlockQuotePlugin,
          EmailPlaceholder,
          AlignmentPlugin,
          Table,
          TableToolbar,
          PasteFromOffice,
          MediaEmbed,
          Font,
          this.ctcVariableSnippetListInsert,
          Image,
          ImageToolbar,
          ImageCaption,
          ImageStyle,
          ImageUploader,
          Underline,
          Strikethrough,
        ],
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
        image: {
          toolbar: [
            "imageStyle:alignLeft",
            "imageStyle:full",
            "imageStyle:alignRight",
            "imageStyle:headerlogo",
          ],
          styles: [
            "full",
            "alignLeft",
            "alignRight",
            {
              name: "headerlogo",
              icon: "left",
              title: "Header Logo Size",
              className: "pdf-header-logo-size",
            },
          ],
        },
        fontSize: {
          options: [
            "tiny",
            "small",
            "default",
            "big",
            "huge",
            6,
            9,
            11,
            13,
            15,
            19,
            21,
            23,
            25,
            27,
            29,
            34,
          ],
        },
        toolbar: {
          items: [
            "undo",
            "redo",
            "|",
            "fontSize",
            "fontFamily",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "alignment",
            "|",
            "bulletedList",
            "numberedList",
            "blockQuote",
            "|",
            "link",
            "MediaEmbed",
            //"imageUpload",
            "|",
            "insertTable",
            "|",
            "EmailPlaceholder",
          ],
        },
      },
      actionTab: "",
      pluralize,
      integrated_search: "",
      filters: {
        search: "",
      },
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL,
      pagination: {
        descending: false,
        rowsPerPage: 25,
      },
      formDialog: false,
      inputFields: {},
      currentObject: {},
      interpolated_headers: true,
      filteredCompanies: [],
      searchInput: "",
    };
  },
  watch: {
    integrated_search: function () {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: this.integrated_search,
      });
    },
    selectedColor: function () {
      this.fillObject("color", this.selectedColor);
    },
    // DETECT COLOR FIELD AND SET COLOR PICKER TO THE RIGHT COLOR
    formDialog: function () {
      if (this.formDialog) {
        if (this.currentObject && this.currentObject.color) {
          this.selectedColor = this.currentObject.color;
        }
      }
    },
  },
  computed: {
    ...mapGetters("commonStore", [
      "text_interpolations",
      "companies",
      "supplier_types",
    ]),
    PlaceholderModale: {
      get() {
        return this.$store.state.commonStore.emailPlaceholderModale;
      },
      set(v) {
        this.$store.state.commonStore.emailPlaceholderModale = v;
        if (!v) {
          // clean loop arrays on close
          this.placeholderModaleLoopArray = [];
          this.placeholderModaleLoopObjects = {};
        }
      },
    },

    plmLoopHtml: function () {
      var str = '<figure class="table"><table>';

      if (this.interpolated_headers == true) {
        str += "<thead " + "><tr>";
      } else str += '<thead style="display: none" ' + "><tr>";

      if (this.interpolated_headers == true) {
        // str += '<thead><tr>';
        this.placeholderModaleLoopArray.forEach((element, index) => {
          str += `<th>
                    <input
                      id="headerInput_${element.replace(/[{ }]/g, "")}"
                      value="${
                        this.placeholderModaleLoopObjects[element].header
                      }"
                      placeholder="${
                        this.placeholderModaleLoopObjects[element].header
                      }">
                  </th>`;
        });
        str += "</tr></thead>";
      }

      str += "<tbody><tr>";
      this.placeholderModaleLoopArray.forEach((element) => {
        str += `<td><span>${element}</span></td>`;
      });
      str += "</tr><tr>";
      this.placeholderModaleLoopArray.forEach((element) => {
        str += `<td><span>${
          this.placeholderModaleLoopObjects[element].need_total
            ? "Total:"
            : "&nbsp"
        }</span></td>`;
      });
      str += "</tr></tbody></table></figure>";
      return str;
    },
  },
  methods: {
    customFilter(items, filters, filter, headers) {
      var columnNames = this.columnsArray;
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);

      cf.registerFilter("search", function (searchWord, items) {
        if (searchWord.trim() === "") return items;

        return items.filter((item) => {
          var ret_value = false;

          columnNames.forEach((colum_name) => {
            let value = "";

            if (Array.isArray(item[colum_name.split(".")[0]])) {
              value = item[colum_name.split(".")[0]]
                .map((e) => e[colum_name.split(".")[1]])
                .join(" ");
            } else if (colum_name.includes(".")) {
              if (item[colum_name.split(".")[0]])
                value =
                  item[colum_name.split(".")[0]][colum_name.split(".")[1]];
            } else {
              value = item[colum_name];
            }

            var tempcheck =
              value != null
                ? value
                    .toString()
                    .toLowerCase()
                    .includes(searchWord.toLowerCase())
                : false;
            if (tempcheck) ret_value = true;
          });
          return ret_value;
        }, searchWord);
      });

      return cf.runFilters();
    },
    cancel() {
      if (this.currentObject.id) {
        this.$store.state.commonStore[
          this.resourceName
        ] = this.$store.state.commonStore[this.resourceName].filter((e) => {
          return e.id != this.currentObject.id;
        });
        this.currentObject = this.tmpObject;
        this.$store.state.commonStore[this.resourceName].push(this.tmpObject);
      }
      this.formDialog = false;
    },
    duplicate(item) {
      this.currentObject = JSON.parse(JSON.stringify(item));
      this.currentObject.name = this.currentObject.name + " (duplicate)";
      if (this.currentObject.language) delete this.currentObject.language;
      if (this.currentObject.step_template_ids)
        delete this.currentObject.step_template_ids;
      delete this.currentObject.id;
      this.showCreateDialog();
    },
    onReady(editor) {
      const toolbarContainer = document.querySelector(
        ".document-editor__toolbar"
      );
      toolbarContainer.appendChild(editor.ui.view.toolbar.element);
    },
    plmLoopExport(title) {
      var delimiter = "#sl";
      if (title == "Expedition Products") delimiter = "#se";

      var exportArr = [];
      for (const key in this.placeholderModaleLoopObjects) {
        if (this.placeholderModaleLoopObjects.hasOwnProperty(key)) {
          //Override Header with dynamique inputs headers fields
          if (this.interpolated_headers === true) {
            this.placeholderModaleLoopObjects[
              key
            ].header = document.getElementById(
              "headerInput_" + key.replace(/[{ }]/g, "")
            ).value;
          } else
            this.placeholderModaleLoopObjects[key].header = "#HIDE_HEADER#";
          exportArr.push(this.placeholderModaleLoopObjects[key]);
        }
      }

      return `${delimiter}[[${JSON.stringify(exportArr)}${delimiter}]]`;
    },
    plmLoopButtonName(item) {
      return this.placeholderModaleLoopArray.indexOf(item.name) == -1
        ? item.description
        : this.placeholderModaleLoopObjects[item.name].need_total
        ? item.description + " (with total)"
        : item.description;
    },
    plmLoopToggle(object) {
      var o = this.placeholderModaleLoopArray.indexOf(object.name);
      if (o == -1) {
        this.placeholderModaleLoopArray.push(object.name);
        this.placeholderModaleLoopObjects[object.name] = {
          header: object.description,
          variable: object.name,
          need_total: false,
        };
      } else {
        if (
          this.placeholderModaleLoopObjects[object.name].need_total == false
        ) {
          // needed for watcher to reset button color
          this.placeholderModaleLoopArray.splice(o, 1);
          this.placeholderModaleLoopArray.push(object.name);
          this.placeholderModaleLoopObjects[object.name].need_total = true;
        } else {
          this.placeholderModaleLoopArray.splice(o, 1);
          delete this.placeholderModaleLoopObjects[object.name];
        }
      }
    },
    ctcVariableSnippetListInsert(editor) {
      editor.conversion.for("upcast").elementToAttribute({
        view: {
          name: "a",
          key: "data-mention",
          classes: "mention",
          attributes: {
            href: true,
          },
        },
        model: {
          key: "mention",
          value: (viewItem) =>
            editor.plugins.get("Mention").toMentionAttribute(viewItem),
        },
        converterPriority: "high",
      });

      editor.conversion.for("downcast").attributeToElement({
        model: "mention",
        view: (modelAttributeValue, viewWriter) => {
          // Do not convert empty attributes (lack of value means no mention).
          if (!modelAttributeValue) {
            return;
          }
          return viewWriter.createAttributeElement("span", {
            "data-mention": modelAttributeValue.id,
          });
        },
        converterPriority: "high",
      });
    },
    ctcVariableSnippetList(ctcVariable) {
      const item = document.createElement("button");
      var itemHtml =
        '<button class="ck ck-button ck-on ck-button_with-text" type="button" tabindex="-1" ><i aria-hidden="true" class="v-icon mention-icon pr-2 v-icon--link material-icons theme--light" style="font-family: ' +
        "'Material Icons' !important" +
        '"' +
        '>settings_ethernet</i><span class="ck ck-tooltip ck-tooltip_s ck-hidden"><span class="ck ck-tooltip__text"></span></span><span class="ck ck-button__label">' +
        ctcVariable.id.replace(/[{}]/g, "") +
        "</span></button>";
      item.innerHTML = itemHtml;
      return item;
    },
    allTextInterpolationsAsArray() {
      var retArr = [];
      this.$store.state.commonStore.text_interpolations.forEach((g) => {
        g.variables.forEach((v) => {
          if (v.name != "{{ null }}")
            //retArr.push({variable:v.name,description:v.description});
            retArr.push({ id: v.name, description: v.description });
          else
            console.error(
              "Interpolation missing! Returned null for " + v.description
            );
        });
      });

      return retArr;
    },
    setEmailPlaceholderModaleTarget(target) {
      this.$store.state.commonStore.emailPlaceholderModaleTarget = target;
      this.PlaceholderModale = true;
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },
    multipleLabel(field) {
      const label = this.camelize(field.name.replace("_ids", ""), " ", true);
      let count = this.currentObject[field.name]
        ? ` (${this.currentObject[field.name].length})`
        : "";

      return label + count;
    },
    emailPlaceholderInsert(string) {
      if (
        this.$store.state.commonStore.emailPlaceholderModaleTarget == "ckeditor"
      ) {
        window.ckeditor.execute("emailPlaceholder", {
          value: string,
        });
        window.ckeditor.editing.view.focus();
      } else {
        var output = this.currentObject[
          this.$store.state.commonStore.emailPlaceholderModaleTarget
        ];
        var cursorIndex = document.getElementById(
          "text_field_" +
            this.$store.state.commonStore.emailPlaceholderModaleTarget
        ).selectionEnd;

        if (output) {
          output =
            output.substring(0, cursorIndex) +
            string +
            output.substring(cursorIndex);
        } else {
          output = string;
        }

        this.currentObject[
          this.$store.state.commonStore.emailPlaceholderModaleTarget
        ] = output;
      }

      this.PlaceholderModale = false;
    },
    udpateCurrentCategoryActions(category, value) {
      Object.keys(category).forEach((cat) => {
        Object.keys(category[cat].actions).forEach((action) => {
          this.udpateCurrentObjectActions(category[cat].actions[action], value);
        });
      });
    },
    udpateCurrentObjectActions(action, value) {
      if (value > 3 || !value) value = 1;
      //Skip verif radio if action is "see"
      if (action.name == "see" && value == 2) value = 3;
      //removing yes and verif ids from currentObject
      this.currentObject["available_action_ids"] = this.currentObject[
        "available_action_ids"
      ].filter(function (a) {
        return a !== action.total.id && a !== action.verif.id;
      });
      if (value == 2)
        this.currentObject["available_action_ids"].push(action.verif.id);
      if (value == 3)
        this.currentObject["available_action_ids"].push(action.total.id);
    },
    actionsRadioGroupValue(action_type_obj) {
      if (this.currentObjecthasAction(action_type_obj.verif.id)) return 2;
      if (this.currentObjecthasAction(action_type_obj.total.id)) return 3;
      return 1;
    },
    actionsRadioGroupLabel(actionsRadioGroupValue) {
      switch (actionsRadioGroupValue) {
        case 0:
        case 1:
          return "No";
        case 2:
          return "Verif";
        case 3:
          return "Yes";
      }
    },
    currentObjecthasAction(action_id) {
      return (
        this.currentObject["available_action_ids"].indexOf(action_id) !== -1
      );
    },
    defineIconColor(actionsRadioGroupValue) {
      switch (actionsRadioGroupValue) {
        case 0:
        case 1:
          return "#ff5b5b";
        case 2:
          return "#ffae5b";
        case 3:
          return "#4ed85f";
      }
    },
    defineActionIcon(action_type) {
      switch (action_type) {
        case "create":
          return "add_circle";
        case "delete":
          return "delete";
        case "update":
          return "edit";
        case "send":
          return "send";
        case "validate":
          return "check_circle";
        case "archive":
          return "archive";
        case "generate":
          return "timeline";
        case "see":
          return "visibility";
        default:
          return "contact_support";
      }
    },
    sanitizeActionName(action, category) {
      var ret = action.replace(/_/gi, " ");
      var re = new RegExp(category, "i");
      ret = ret.replace(re, " ");
      return ret;
    },
    addAll(resource_ids) {
      const resource_name = pluralize(resource_ids.replace("_ids", ""), 2);
      var ressources = this.$store.state.commonStore[
        resource_name.replace("_of_destination", "").replace("_of_origin", "")
      ];
      const old_ids = this.currentObject[resource_ids] || [];

      const search = this.searchInput;
      /* Filtered values based on user input */
      if (search) {
        ressources = ressources.filter((e) => {
          return e.name.includes(search) && !old_ids.includes(e.id);
        });
      }
      const ids = ressources
        .map((e) => {
          return e.id;
        })
        .concat(old_ids);

      this.fillObject(resource_ids, ids);
      this.currentObject = JSON.parse(JSON.stringify(this.currentObject));
    },
    camelize(str, sep = "", plural = false) {
      return pluralize(
        str
          .split("_")
          .map((w) => w.replace(/./, (m) => m.toUpperCase()))
          .join(sep),
        plural ? 2 : 1
      );
    },
    fetchAvailableActionsByGroup() {
      let obj = {};

      this.$store.state.commonStore.available_action_groups.forEach((e) => {
        obj[e.name] = this.fetchAvailableActions(e.available_actions);
      });

      return obj;
    },

    fetchAvailableActions(availableActions) {
      let actionCategory, actionType;
      let allActionsByCategories = {};

      availableActions.forEach((availableAction) => {
        actionCategory = this.camelize(
          availableAction.name
            .replace("_with_verif", "")
            .split("_")
            .slice(2)
            .join(" "),
          " "
        );
        actionType = availableAction.name.split("_").slice(1, 2)[0];

        if (!(actionCategory in allActionsByCategories)) {
          allActionsByCategories[actionCategory] = { actions: {} };
          allActionsByCategories[actionCategory]["pluralized"] = this.pluralize(
            actionCategory,
            2
          );
        }

        if (!(actionType in allActionsByCategories[actionCategory].actions))
          allActionsByCategories[actionCategory].actions[actionType] = {
            name: actionType,
            icon: this.defineActionIcon(actionType),
            total: {},
            verif: {},
            value: 0,
          };

        allActionsByCategories[actionCategory].actions[actionType][
          availableAction.name.indexOf("with_verif") == -1 ? "total" : "verif"
        ] = availableAction;
      });

      for (var c in allActionsByCategories)
        for (var a in allActionsByCategories[c].actions) {
          allActionsByCategories[c].actions[
            a
          ].value = this.actionsRadioGroupValue(
            allActionsByCategories[c].actions[a]
          );
        }

      return allActionsByCategories;
    },
    fetchCollection(field) {
      if (field.description && field.description.startsWith("filter:")) {
        const condition = field.description.replace("filter: ", "");

        const or = condition.split("||");
        let res = [];
        let tmp = null;

        or.forEach((filter) => {
          const split = filter.split(" == ");
          const filterOn = split[0].trim();
          let val = split[1].trim();
          if (val == "true") val = true;
          if (val == "false") val = false;

          if (field.name.endsWith("_ids")) {
            tmp = this.$store.state.commonStore[
              this.plural(field.name.replace("_ids", ""))
            ];
            res = res.concat(
              tmp.filter((e) => {
                return e[filterOn] == val;
              })
            );
          }

          if (field.name.endsWith("_id")) {
            tmp = this.$store.state.commonStore[
              this.plural(field.name.replace("_id", ""))
            ];
            res = res.concat(
              tmp.filter((e) => {
                return e[filterOn] == val;
              })
            );
          }
        });
        return res;
      }
      if (field.description == "step_templates")
        console.log(this.$store.getters[`commonStore/${field.description}`]);
      if (field.description)
        return this.$store.getters[`commonStore/${field.description}`];

      if (field.name.endsWith("_ids")) {
        return this.$store.state.commonStore[
          this.plural(field.name.replace("_ids", ""))
        ];
      }

      if (field.name.endsWith("_id"))
        return this.$store.state.commonStore[
          this.plural(field.name.replace("_id", ""))
        ];
    },
    truncate(string, length) {
      return string.length > length
        ? string.substring(0, length - 1) + "..."
        : string;
    },
    showEditDialog(obj) {
      this.tmpObject = JSON.parse(JSON.stringify(obj));
      this.currentObject = obj;
      this.fetchInputFields(this.inputType());
      if (this.source == "shipping_market") {
        let retSupp = this.supplier_types.find(
          (s) => s.name == this.resourceDisplayName
        );
        this.filteredCompanies = this.$store.state.commonStore.companies.filter(
          (c) => {
            return (
              c.supplier &&
              c.supplier.supplier_type.id == (retSupp ? retSupp.id : "")
            );
          }
        );
        this.currentObject["supplier_type_id"] = retSupp ? retSupp.id : "";
      }
      this.formDialog = true;
    },
    showCreateDialog() {
      if (this.currentObject.id) this.currentObject = {};
      this.fetchInputFields(this.inputType());
      if (this.source == "shipping_market") {
        let retSupp = this.supplier_types.find(
          (s) => s.name == this.resourceDisplayName
        );
        this.filteredCompanies = this.$store.state.commonStore.companies.filter(
          (c) => {
            return (
              c.supplier &&
              c.supplier.supplier_type.id == (retSupp ? retSupp.id : "")
            );
          }
        );
        this.currentObject["supplier_type_id"] = retSupp ? retSupp.id : "";
      }
      this.formDialog = true;
    },
    save() {
      this.mutationLoading = true;
      if (this.currentObject.id) this.update();
      else this.create();
    },
    update() {
      const resName = pluralize(this.resourceName, 1);
      const argsList = Object.keys(this.currentObject).map((k) => {
        let self = this;
        if (!this.inputFields.find((e) => e.name == k)) return "";

        if (k.endsWith("_ids"))
          return `${k}: [${this.currentObject[k]
            .map((e) => `"${e}"`)
            .join(",")}]`;

        const type = this.inputFields.find((e) => e.name == k).type;
        if (type.name == "Boolean")
          return this.currentObject[k] ? `${k}: true` : `${k}: false`;

        if (type.name == "Int" || type.name == "Float" || type.kind == "ENUM")
          return this.currentObject[k] ? `${k}: ${this.currentObject[k]}` : "";

        return `${k}: """
          ${this.currentObject[k] && this.currentObject[k].replace(/"/g, '\\"')}
        """`;
      });

      const selectors = Object.keys(this.currentObject)
        .filter((k) => this.inputFields.find((e) => e.name == k))
        .concat(["id"])
        .join("\n");

      const mutation = gql`
          mutation {
            update_${resName}(
              id: "${this.currentObject.id}"
              ${resName}: { ${argsList} }
            ) { ${selectors} }
          }

        `;

      this.sendMutation("updated", this.singularName(), mutation)
        .then((data) => {
          this.formDialog = false;
          this.mutationLoading = false;
          this.$store.commit("commonStore/hydrateObject", {
            id: this.currentObject.id,
            model: pluralize(resName, 2),
            newObject: data[`update_${resName}`],
          });
        })
        .catch(() => {
          this.mutationLoading = false;
        });
    },
    create() {
      const resName = pluralize(this.resourceName, 1);
      const argsList = Object.keys(this.currentObject).map((k) => {
        const field = this.inputFields.find((e) => e.name == k);

        if (!field) return "";
        if (this.currentObject[k] == undefined || this.currentObject[k] == null)
          return "";
        const type = field.type;

        if (k.endsWith("_ids"))
          return `${k}: [${this.currentObject[k]
            .map((e) => `"${e}"`)
            .join(",")}]`;

        if (
          type.name == "Boolean" ||
          type.name == "Int" ||
          type.name == "Float" ||
          type.kind == "ENUM"
        )
          return this.currentObject[k] ? `${k}: ${this.currentObject[k]}` : "";

        return `${k}: """
          ${this.currentObject[k] && this.currentObject[k].replace(/"/g, '\\"')}
        """`;
      });

      const selectors = Object.keys(this.currentObject)
        .concat(["id"])
        .join("\n");

      const mutation = gql`
          mutation {
            create_${resName}(
              ${resName}: { ${argsList} }
            ) { ${selectors} }
          }
        `;

      this.sendMutation("created", this.singularName(), mutation)
        .then(() => {
          this.formDialog = false;
          this.mutationLoading = false;
          this.currentObject = {};
        })
        .catch(() => {
          this.mutationLoading = false;
        });
    },
    fillObject(fieldName, res) {
      this.$set(this.currentObject, fieldName, res);
    },
    fetchInputFields(givenInputType) {
      const query = gql`
          {
            __type(name: "${givenInputType}") {
              name
              description
              inputFields {
                name
                description
                type {
                  name
                  kind
                  enumValues {
                    name
                  }
                }
              }
            }
          }
        `;
      this.sendQuery(query).then((data) => {
        this.inputFields = data.__type.inputFields;
      });
    },
    plural(str) {
      return pluralize(str, 2);
    },
    singular(str) {
      return pluralize(str, 1);
    },
    fetchValue(item, column) {
      let res = item;
      if (column.endsWith(".count")) {
        let splited = column.split(".");
        splited.splice(splited.length - 1);

        return `${
          res[pluralize(splited[0], 1) + "_ids"].length
        } ${this.camelize(splited[0], " ", true)}`;
      } else
        column.split(".").forEach((e) => {
          if (Array.isArray(res)) res = res.map((t) => t[e]).join(", ");
          else res = res[e] != null && res != undefined ? res[e] : "";
        });

      return res;
    },
    singularName() {
      return pluralize(this.resourceDisplayName, 1);
    },
    inputType() {
      return this.camelize(this.resourceName) + "InputType";
    },
    fetchHeaders() {
      return this.columnsArray
        .map((e) => {
          const text = e.endsWith(".count")
            ? pluralize(this.camelize(e.split(".")[0], " "), 2)
            : this.camelize(e.split(".")[0], " ");
          return {
            text: text,
            align: "left",
            sortable: true,
            value: e,
          };
        })
        .concat([{ text: "Actions", align: "left", sortable: false }]);
    },
  },
};
</script>

<style scoped>
.text_field_action >>> .v-input__icon {
  background-color: var(--v-primary-base) !important;
  border-radius: 16px !important;
}

.text_field_action >>> i {
  font-size: 16px !important;
  color: white !important;
}

i.v-icon.v-icon--link.material-icons.theme--light {
  font-family: "Material Icons" !important;
  font-weight: normal;
  font-style: normal;
}
</style>

<style>
.vue-swatches__trigger__wrapper {
  display: block;
}

.vue-swatches__wrapper {
  width: auto !important;
}

.vue-swatches__container:not(.vue-swatches--inline) {
  position: initial !important;
}
</style>

<style lang="stylus">
.mini {
  .v-expansion-panel__header {
    min-height: 0;
    padding: 5px 24px !important;
  }

  tbody {
    tr {
      height: 60px !important;

      td {
        height: 20px !important;
      }
    }
  }
}

.reducedLPadding {
  .v-list__group__items--no-action .v-list__tile {
    padding-left: 6px;
  }
}

.capitalize {
  text-transform: capitalize !important;
}

.v-input--radio-group--column .v-input--radio-group__input>.v-label {
  text-transform: capitalize !important;
}
</style>
